import React from 'react';

const MensagemDeErro = ({ campo='', mensagem='Campo obrigatório' }) => (
  <p className="formulario__mensagem formulario__mensagem_erro" data-test-id={`${campo}ComErro`}>
    <i className="far fa-times formulario__mensagem-icone"></i> {mensagem}
  </p>
);

export default MensagemDeErro;